import type { ReactElement } from 'react'
import { useCallback, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LandingPageLoyaltyAirportTransferBenefitsModal from './LandingPageLoyaltyAirportTransferBenefitsModal'

interface Props {
  layout: 'tile' | 'row'
  benefitLabel: ReactElement
}

function LandingPageLoyaltyAirportTransfersTile(props: Props) {
  const { layout, benefitLabel } = props
  const showModal = useContext(ModalContext)
  const intl = useIntl()
  const image = useMemo<App.Image>(() => ({
    id: '0qt5tc9nvf1qd3f0t5fe',
    title: intl.formatMessage({
      id: '2HRtf-FUlQHl0uAxrGqo',
      defaultMessage: 'Free airport chauffeur service',
      description: 'Alternative text fallback for the airport chauffeur service loyalty benefit image',
    }),
  }), [intl])

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyAirportTransferBenefitsModal image={image} />)
  }, [image, showModal])

  return <LandingPageLoyaltyBenefitTile
    layout={layout}
    benefitType="airport_transfer"
    heading={intl.formatMessage({
      defaultMessage: 'Free airport chauffeur transfers',
      id: 'OZv7wX049XAjsYi4I9Z2',
      description: 'Heading for loyalty airport chauffeur transfer benefit tile',
    })}
    subtitle={benefitLabel}
    onClick={handleDetailsClick}
  />
}

export default LandingPageLoyaltyAirportTransfersTile
